export default __webpack_public_path__ + "static/media/AcornMallCarpark_07.3dd0745d.png";